/* Cubold header: dropdown panels, search bar, mobile drawer, series finder */
(function () {
  document.querySelectorAll('.cg-mega, .cg-narrow').forEach(function (el) {
    if (el.parentElement !== document.body) document.body.appendChild(el);
  });
  ['cg-srch', 'cg-drawer'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
  });

  var nav = document.getElementById('cg-nav');
  var srchBtn = document.getElementById('cg-srch-btn');
  var srchBar = document.getElementById('cg-srch');
  var hamBtn = document.getElementById('cg-ham');
  var drawer = document.getElementById('cg-drawer');
  if (!nav || !srchBtn || !srchBar || !hamBtn || !drawer) return;

  var active = null, closeT = null, srchOpen = false, mobOpen = false;
  var allPanels = Array.prototype.slice.call(document.querySelectorAll('.cg-mega, .cg-narrow, #cg-srch'));

  function annHeight() {
    var ann = document.querySelector('[id*="announcement"]');
    if (ann) return Math.max(0, ann.getBoundingClientRect().bottom);
    return window.innerWidth <= 900 ? 34 : 44;
  }

  function navBottom() {
    return Math.round(nav.getBoundingClientRect().bottom);
  }

  function updatePanelTops() {
    var bottom = navBottom() + 'px';
    allPanels.forEach(function (el) { el.style.top = bottom; });
    drawer.style.top = bottom;
  }

  function onScroll() {
    var scrollY = Math.max(0, window.scrollY || 0);
    nav.style.top = Math.max(0, annHeight() - scrollY) + 'px';
    nav.classList.toggle('scrolled', scrollY > 10);
    updatePanelTops();
  }

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  function closeAll() {
    if (active) { active.classList.remove('open'); active = null; }
    document.querySelectorAll('#cg-links li.is-open').forEach(function (x) { x.classList.remove('is-open'); });
  }

  function openPanel(li) {
    clearTimeout(closeT);
    var panel = document.getElementById('p-' + li.dataset.p);
    if (!panel) { closeAll(); return; }

    if (active && active !== panel) {
      active.classList.remove('open');
      document.querySelectorAll('#cg-links li.is-open').forEach(function (x) { x.classList.remove('is-open'); });
    }

    if (panel.classList.contains('cg-narrow')) {
      var r = li.getBoundingClientRect();
      panel.style.left = r.left + 'px';
      panel.style.right = 'auto';
    }

    requestAnimationFrame(function () { panel.style.top = navBottom() + 'px'; });

    panel.classList.add('open');
    li.classList.add('is-open');
    active = panel;

    var links = Array.prototype.slice.call(panel.querySelectorAll('a'));
    links.forEach(function (a) { a.style.opacity = '0'; a.style.transform = 'translateY(-4px)'; });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        links.forEach(function (a, i) {
          setTimeout(function () {
            a.style.transition = 'opacity 0.15s ease, transform 0.15s ease, color 0.12s, background 0.12s';
            a.style.opacity = '1';
            a.style.transform = 'translateY(0)';
          }, i * 8);
        });
      });
    });
  }

  document.querySelectorAll('#cg-links li[data-p]').forEach(function (li) {
    li.addEventListener('mouseenter', function () { openPanel(li); });
    li.addEventListener('mouseleave', function (e) {
      var panel = document.getElementById('p-' + li.dataset.p);
      if (e.relatedTarget && panel && panel.contains(e.relatedTarget)) return;
      closeT = setTimeout(closeAll, 140);
    });
    li.addEventListener('click', function () { openPanel(li); });
  });

  document.querySelectorAll('.cg-mega, .cg-narrow').forEach(function (panel) {
    panel.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    panel.addEventListener('mouseleave', function () { closeT = setTimeout(closeAll, 140); });
  });

  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target) && !e.target.closest('.cg-mega') && !e.target.closest('.cg-narrow')) closeAll();
  });

  srchBtn.addEventListener('click', function () {
    srchOpen = !srchOpen;
    srchBar.classList.toggle('open', srchOpen);
    if (srchOpen) { closeAll(); setTimeout(function () { srchBar.querySelector('input').focus(); }, 20); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { srchOpen = false; srchBar.classList.remove('open'); closeAll(); }
  });

  hamBtn.addEventListener('click', function () {
    mobOpen = !mobOpen;
    hamBtn.classList.toggle('open', mobOpen);
    drawer.classList.toggle('open', mobOpen);
    document.body.style.overflow = mobOpen ? 'hidden' : '';
  });

  document.querySelectorAll('.cg-mob-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sec = btn.closest('.cg-mob-section');
      var wasOpen = sec.classList.contains('open');
      document.querySelectorAll('.cg-mob-section.open').forEach(function (s) { s.classList.remove('open'); });
      if (!wasOpen) sec.classList.add('open');
    });
  });

  document.querySelectorAll('.cg-mob-subtrigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = btn.closest('.cg-mob-sub');
      var wasOpen = sub.classList.contains('open');
      sub.parentElement.querySelectorAll('.cg-mob-sub.open').forEach(function (s) { s.classList.remove('open'); });
      if (!wasOpen) sub.classList.add('open');
    });
  });

  /* Find a series inside the mega menu */
  document.querySelectorAll('[data-cg-find]').forEach(function (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var panel = input.closest('.cg-mega');
      panel.querySelectorAll('.cg-mega-col a').forEach(function (a) {
        a.hidden = !!q && a.textContent.toLowerCase().indexOf(q) === -1;
      });
      panel.querySelectorAll('.cg-mega-col').forEach(function (col) {
        col.hidden = !!q && !col.querySelector('a:not([hidden])');
      });
      var tiles = panel.querySelector('.cg-mega-tiles');
      if (tiles) tiles.hidden = !!q;
    });
  });
})();